import { Component, Input, OnInit } from '@angular/core';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { EspaceDocumentaireService } from '@kv-common-components/kx-services';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-signature-steps',
    templateUrl: 'signature-steps.component.html',
})
export class SignatureStepsComponent implements OnInit {
    @Input() espaceClient;
    @Input() allDocuments;
    @Input() idPropo;
    finalisationEcretementInfo: string;
    areasCorrespondType: string;
    areasCorrespondNumero: string;
    propositionAssuranceTypologie = 'ADH3219';
    idDocument: string;

    constructor(
        private i18nPipe: I18nPipe,
        private logger: NGXLogger,
        private espaceDocumentaireService: EspaceDocumentaireService
    ) {}

    ngOnInit(): void {
        this.areasCorrespondType = this.i18nPipe.transform(
            'finalisation.ecretement.correspondant.aeras.' +
                this.espaceClient.idApporteurPrincipal +
                '.type'
        );
        this.areasCorrespondNumero = this.i18nPipe.transform(
            'finalisation.ecretement.correspondant.aeras.' +
                this.espaceClient.idApporteurPrincipal +
                '.numero'
        );

        if (
            this.areasCorrespondType === 'vert' ||
            this.areasCorrespondType === 'gris'
        ) {
            this.finalisationEcretementInfo =
                'finalisation.ecretement.information.paraph3';
        } else {
            this.finalisationEcretementInfo =
                'finalisation.ecretement.information.paraph4';
        }
        window.scrollTo(0, 0);
    }

    downloadPropositionAssurance() {
        const fileNamePorpositionAssurance = "Proposition d'assurance";

        // on verifie si une porposition assurance est disponible en ged
        const propositionAssurance = this.allDocuments.find(
            (doc) => doc.typologie === this.propositionAssuranceTypologie
        );

        // si proposition assurance existe alors on prend l'idGed
        // sinon on appelle une methode pour generer la propose en fonction de la typologie
        if (propositionAssurance) {
            this.idDocument = propositionAssurance.idGed;
        } else {
            this.idDocument =
                '_toGenerate_' + this.propositionAssuranceTypologie;
        }

        this.espaceDocumentaireService
            .downloadDocument(
                this.espaceClient.personne.idPersonne,
                this.idPropo,
                this.idDocument,
                fileNamePorpositionAssurance
            )
            .subscribe((success) => {
                if (success) {
                    this.logger.debug('success download propo assurance');
                }
            });
    }
}
